import BMapLib from 'BMapLib'
import BMap from 'BMap'
import iconUrl from '../assets/track_person.png'

BMapLib.LuShu.prototype._move = function (initPos, targetPos, effect) {
  // var pointsArr = [initPos, targetPos]; //点数组
  var me = this,
      //当前的帧数
      currentCount = 0,
      //步长，米/秒
      timer = 10,
      step = this._opts.speed / (1000 / timer),
      //初始坐标
      init_pos = this._projection.lngLatToPoint(initPos),
      //获取结束点的(x,y)坐标
      target_pos = this._projection.lngLatToPoint(targetPos),
      //总的步长
      count = Math.round(me._getDistance(init_pos, target_pos) / step);
  //显示折线 syj201607191107
  // this._map.addOverlay(new BMap.Polyline(pointsArr, {
  //   strokeColor: "#111",
  //   strokeWeight: 5,
  //   strokeOpacity: 0.5
  // })); // 画线
  //如果小于1直接移动到下一点
  if (count < 1) {
    setTimeout(()=> {
      me._moveNext(++me.i);
    },1000)
  }else{
    if(me._intervalFlag){
      clearInterval(me._intervalFlag);
      me._intervalFlag = null
    }
    me._intervalFlag = setInterval(function () {
      //两点之间当前帧数大于总帧数的时候，则说明已经完成移动
      if (currentCount >= count) {
        clearInterval(me._intervalFlag);
        //移动的点已经超过总的长度
        if (me.i > me._path.length) {
          return;
        }
        //运行下一个点
        me._moveNext(++me.i);
      } else {
        currentCount++;
        var x = effect(init_pos.x, target_pos.x, currentCount, count),
            y = effect(init_pos.y, target_pos.y, currentCount, count),
            pos = me._projection.pointToLngLat(new BMap.Pixel(x, y));
        //正在移动
        me._marker.setPosition(pos);
        //设置自定义overlay的位置
        me._setInfoWin(pos);
      }
    }, timer);
  }

}
BMapLib.LuShu.prototype._moveNext = function (index) {
  console.log('调用_moveNext，index=' + index)
  var me = this;
  me.showIndoorTrack(me._path[index],index)
}
BMapLib.LuShu.prototype._moveNext2 = function (index) {
  var me = this;
  // index 不是最后一个点
  if (index < this._path.length - 1) {
    //me.showIndoorTrack(me._path[index])
    me._move(me._path[index], me._path[index + 1], me._tween.linear);
  } else {
    // index已经是最后一个点，说明运动已经完成
    // 隐藏显示框
    //me.showIndoorTrack(me._path[index])
    me.hideInfoWindow()
  }
}



let PersonIcon = new BMap.Icon(iconUrl, new BMap.Size(56, 28), {
  anchor: new BMap.Size(12, 24)
})
/**
 *
 * 这是一个用来展示百度地图运动轨迹的类
 * @class MapLuShu
 */
class MapLuShu {
  constructor(map, points, options,showIndoorTrack) {
    this.map = map
    this.points = points
    this.options = Object.assign({}, {
      landmarkPois: [],
      icon: PersonIcon,
      // speed:
      autoView: true,
      enableRotation: true
    }, options)
    this.init(showIndoorTrack)
  }
  init(showIndoorTrack) {
    this.Lushu = new BMapLib.LuShu(this.map, this.points, this.options)
    this.Lushu.showIndoorTrack = showIndoorTrack
  }
  start() {
    this.Lushu.start()
  }
  pause() {
    this.Lushu.pause()
  }
  stop() {
    this.Lushu.stop()
  }
  hide() {
    this.Lushu.hideInfoWindow()
  }
  moveNext(index) {
    this.Lushu._moveNext2(index)
  }
}
export default MapLuShu